import {getMeasurementValue} from "./getMeasurementValue";

export const filterMeasurementsByMetric = ({
  measurements,
  metric
}) => (
  measurements
    .filter((measure) => measure.type === metric)
    .sort((measureA, measureB) =>
      new Date(measureB.measureDateTime).getTime() - new Date(measureA.measureDateTime).getTime()
    )
    .map((measure) => ({
      id: measure.id,
      dateTime: measure.measureDateTime,
      value: getMeasurementValue(measure),
      raw: measure,
    }))
);
